import { render, staticRenderFns } from "./KeyboardControl.vue?vue&type=template&id=7fb070f2&scoped=true&"
import script from "./KeyboardControl.vue?vue&type=script&lang=js&"
export * from "./KeyboardControl.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardControl.vue?vue&type=style&index=0&id=7fb070f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb070f2",
  null
  
)

export default component.exports